import styled from 'styled-components';
import slide2 from 'assets/images/mobile/slide2.jpg';
export { SubtitleMobile } from 'styles/shared';

export const Container = styled.section`
  width: 100%;
  min-height: 100vh;
`;

export const Image = styled.img.attrs({ src: slide2 })`
  width: 100%;
`;

export const Content = styled.div`
  width: 100%;
  padding: 32px 48px;
`;
